export interface MapTheme
{
    id: string;
    value: string;
    name: string;
    icon: string;
    default?: boolean;
}

export const mapThemes = Object.freeze<MapTheme[]>([
    {
        id: "light-v10",
        value: "mapbox://styles/mapbox/light-v10",
        name: "Light",
        icon: "/map_assets/light.png",
        default: true
    },
    {
        id: "streets-v11",
        value: "mapbox://styles/mapbox/streets-v11",
        name: "Streets",
        icon: "/map_assets/streets.png"
    },
    {
        id: "dark-v10",
        value: "mapbox://styles/mapbox/dark-v10",
        name: "Dark",
        icon: "/map_assets/dark.png"
    },
    {
        id: "satellite-v9",
        value: "mapbox://styles/mapbox/satellite-v9",
        name: "Satellite",
        icon: "/map_assets/satellite.png"
    }
]);